import { DecodeHtml } from '../../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../../utils/getAssets'

const ResearchExpertise = ({ college }) => {
  const data = college?.mediaResearch_new?.items?.map(d => {
    d = d?.content?.properties
    return {
      info: DecodeHtml({ html: d?.information?.markup }),
      image: d?.image ? retrunAssets(d?.image[0]?.url) : returnNotImage(),
      expertise: DecodeHtml({ html: d?.expertise?.markup })
    }
  })

  return (
    <div className='flex flex-col gap-8 p-4 md:px-10 w-full'>
      <h1 className='text-3xl font-bold '>Research Experties</h1>
      <div className='grid grid-cols-[repeat(auto-fill,_minmax(15rem,_1fr))]  w-full gap-5'>
        {data?.map((d, i) => (
          <div key={i} className='flex flex-col gap-5 h-fit w-full'>
            <div
              className='h-[22rem] relative border shrink-0 snap-center group select-none bg-slate-500/30 rounded-3xl overflow-hidden bg-cover bg-no-repeat bg-center'
              style={{
                backgroundImage: `url(${d?.image})`
              }}
            >
              <div className='absolute w-full h-full top-0 bg-gradient-to-b from-black/20 to-black/40 z-20 opacity-0 group-hover:opacity-100 transition-all duration-500'></div>
              <div className='absolute bottom-0 w-full h-[40%]  overflow-y-auto z-30 hide-scrollbar text-white bg-gradient-to-b from-[#6e6e76]/30 to-[#1b1b1d] px-5 pt-2'>
                {d?.info}
              </div>
            </div>
            {d?.expertise}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ResearchExpertise
